(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campvaro-climate-advisor-v1"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.cvInit)return;root.dataset.cvInit='1';
    var form=root.querySelector('.cv-ca__form'),result=root.querySelector('.cv-ca__result'),steps=[].slice.call(root.querySelectorAll('.cv-ca-step')),idx=0,products={};
    try{products=JSON.parse(root.querySelector('script[type="application/json"]').textContent);}catch(e){}
    function show(i){idx=i;steps.forEach(function(s,n){s.classList.toggle('is-active',n===i)});root.querySelector('.cv-ca-prev').disabled=i===0;root.querySelector('.cv-ca-next').textContent=i===steps.length-1?'Bekijk mijn advies':'Volgende';root.querySelector('.cv-ca__progress span').style.width=((i+1)/steps.length*100)+'%'}
    function valid(){return !!steps[idx].querySelector('input:checked')}
    function val(n){var x=form.querySelector('[name="'+n+'"]:checked');return x?x.value:null}
    function card(k,label){var p=products[k];if(!p)return '<div class="cv-ca-product"><div><strong>'+label+'</strong><br><small>Vraag CampVaro om passend productadvies.</small></div></div>';return '<div class="cv-ca-product">'+(p.image?'<img src="'+p.image+'" alt="">':'')+'<div><strong>'+label+'</strong><br><a class="button" href="'+p.url+'">Bekijk product</a></div></div>'}
    function altReason(k){return {rta1700:'Compactere 230V-keuze voor voertuigen tot 7 meter wanneer extra koelreserve niet nodig is.',rta2200:'Meer koelreserve voor grotere voertuigen, hoge zonbelasting of intensiever gebruik; geschikt tot 8 meter.',rta12v:'12V-alternatief wanneer onafhankelijk koelen zonder aparte 230V-omvormer voor de airco belangrijk is.'}[k]||''}
    function advise(){
      var use=val('use'),power=val('power'),length=val('length'),heat=val('heat'),load=val('load'),ind=val('independence'),roof=val('roof');
      var primary=null,alts=[],profile='',reason=[],warn=[];
      var need=val('need');
      var highDemand=(length==='large'||heat==='hot'||load==='heavy'||(heat==='warm'&&load!=='light'));
      if(need==='ventilation'){
        primary='maxxfan';profile='Climate Essential';
        reason.push('Je zoekt luchtverversing en ventilatiecomfort. MaxxFan Deluxe voert lucht aan of af en werkt ook bij regen. Hij koelt niet actief onder de buitentemperatuur.');
        warn.push('Controleer 400 × 400 mm dakopening, 25–90 mm dakdikte, vrije ruimte en beveiligde 12V-voeding. Luchttoevoer blijft nodig.');
      }else if(need==='unknown'){
        profile='Aanvullende klimaatcheck nodig';warn.push('Bepaal eerst of luchtverversing voldoende is of actieve koeling nodig is.');
      }else if(length==='xl'||power==='unknown'){
        profile='Aanvullende klimaatcheck nodig';warn.push('Voertuiglengte of onbekende stroomvoorziening vraagt een persoonlijke beoordeling.');
      }else if(power==='12'){
        profile='Climate Pro';
        if(length==='large') warn.push('De RTA-2000 12V is opgegeven tot circa 7 meter. Voor 7–8 meter geven we geen automatische productmatch.');
        else {primary='rta12v';reason.push('Je wilt de airco rechtstreeks op 12V gebruiken. De RTA-2000 12V is een kandidaat na controle van accu, laadcapaciteit, kabels en beveiliging.');}
      }else if(power==='both'||use==='offgrid'||ind==='high'){
        profile='Climate Pro';warn.push('Koelen zonder walstroom vraagt een berekening van koeluren, accucapaciteit, werkelijk elektrisch verbruik en laadmogelijkheden. We kiezen geen 12V- of 230V-setup zonder die controle.');
      }else{
        profile='Climate Freedom';primary=highDemand?'rta2200':'rta1700';
        reason.push('Je kiest actieve koeling op 230V. De '+(primary==='rta2200'?'RTA-2200i biedt extra koelreserve voor voertuigen tot circa 8 meter.':'RTA-1700i is een compacte kandidaat voor voertuigen tot circa 7 meter.')+' Voertuiglengte is een indicatie; isolatie, glas en zon bepalen mede de koelvraag.');
        if(primary==='rta1700') alts=['rta2200'];
        warn.push('Binnenunit en luchtverdeler zijn inbegrepen. CampVaro levert zonder montage; installatie door een installateur is vereist. Controleer de 230V-aansluiting met de installatiegegevens.');
      }
      if(roof!=='yes') warn.push('Dakopening, dakdikte, draagkracht en montagepositie zijn nog te controleren.');
      if(primary==='rta12v') warn.push('12V betekent geen laag verbruik of gegarandeerd aantal koeluren. Eerst de energiecheck afronden.');

      root.querySelector('.cv-ca-profile').textContent=profile;
      root.querySelector('.cv-ca-summary').textContent=primary?(primary==='maxxfan'?'Je zoekt ventilatie en luchtverversing. Daarom onderzoeken we deze ventilatieoplossing.':'Op basis van voertuiglengte, warmtebelasting, stroomvoorziening en reisstijl onderzoeken we deze klimaatrichting.'):'We hebben eerst aanvullende informatie nodig om een passende productrichting te kiezen.';
      root.querySelector('.cv-ca-primary').innerHTML=primary?'<h3>Te controleren richting</h3>'+card(primary,products[primary]?products[primary].title:'Beste match'):'<h3>Persoonlijke beoordeling aanbevolen</h3>';
      root.querySelector('.cv-ca-reason').innerHTML='<h3>Waarom dit advies?</h3><p>'+reason.join(' ')+'</p>';
      root.querySelector('.cv-ca-warning').innerHTML=warn.length?'<div class="cv-ca-note"><strong>Controleer vóór bestelling</strong><br>'+warn.join(' ')+'</div>':'';
      root.querySelector('.cv-ca-alts').innerHTML=alts.length?'<h3>Alternatieven</h3>'+alts.map(function(k){return card(k,products[k]?products[k].title:k)+'<p class="cv-ca-alt-reason">'+altReason(k)+'</p>'}).join(''):'';
      root.querySelector('.cv-ca-check').innerHTML='<div class="cv-ca-note"><strong>CampVaro-check</strong><br>Dakventilatie en airco vragen een passende installatie. Controleer altijd dakmaat, draagkracht, elektrische aansluiting en installatievoorwaarden voordat je bestelt. <a href="/pages/contact">Controleer mijn setup met CampVaro</a>.</div>';
      form.hidden=true;result.hidden=false;result.scrollIntoView({behavior:'smooth',block:'start'});
    }
    root.querySelector('.cv-ca-next').addEventListener('click',function(){if(!valid()){steps[idx].querySelector('label').scrollIntoView({behavior:'smooth',block:'center'});return}if(idx===0 && val('need')!=='cooling') advise();else if(idx<steps.length-1)show(idx+1);else advise()});
    root.querySelector('.cv-ca-prev').addEventListener('click',function(){if(idx>0)show(idx-1)});
    root.querySelector('.cv-ca-restart').addEventListener('click',function(){form.reset();result.hidden=true;form.hidden=false;show(0)});
    show(0);
  }
  function boot(){document.querySelectorAll('[id^="CampVaroClimateAdvisor-"]').forEach(init)}
  document.addEventListener('DOMContentLoaded',boot);document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[id^="CampVaroClimateAdvisor-"]')||e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campvaro-offgrid-energy-advisor"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.cvInit) return;
    root.dataset.cvInit='1';
    var form=root.querySelector('.cv-ea__form'), result=root.querySelector('.cv-ea__result');
    if(!form) return;
    var steps=[].slice.call(root.querySelectorAll('.cv-step')), idx=0, products={};
    try{products=JSON.parse(root.querySelector('script[type="application/json"]').textContent);}catch(e){}

    var specs={
      ab120:{wh:1536,route:'allinone'},ab200:{wh:2560,route:'allinone'},ab300:{wh:3840,route:'allinone'},
      us280:{wh:3584,route:'installed',height:145},us320:{wh:4096,route:'installed',height:190},
      us540:{wh:6912,route:'installed',height:190},us700:{wh:8960,route:'installed',height:220}
    };

    function show(i){
      idx=i; steps.forEach(function(s,n){s.classList.toggle('is-active',n===i)});
      root.querySelector('.cv-prev').disabled=i===0;
      root.querySelector('.cv-next').textContent=i===steps.length-1?'Bekijk mijn advies':'Volgende';
      root.querySelector('.cv-ea__progress span').style.width=((i+1)/steps.length*100)+'%';
    }
    function valid(){
      var input=form.querySelector('[name="chargewh"]'), validCharge=!input||input.value===''||input.checkValidity();
      root.querySelector('.cv-charge-error').hidden=validCharge;
      return !!steps[idx].querySelector('input:checked') && (idx!==5||validCharge);
    }
    function val(name){var x=form.querySelector('[name="'+name+'"]:checked');return x?x.value:null;}
    function card(key,label){
      var p=products[key];
      if(!p) return '<div class="cv-product-card"><div><strong>'+label+'</strong><br><small>Vraag CampVaro om passend productadvies.</small></div></div>';
      return '<div class="cv-product-card">'+(p.image?'<img src="'+p.image+'" alt="">':'')+'<div><strong>'+label+'</strong><br><a class="button" href="'+p.url+'">Bekijk product</a></div></div>';
    }
    function capacityKey(route,need,space){
      if(route==='allinone'){
        if(need<=1536) return 'ab120';
        if(need<=2560) return 'ab200';
        if(need<=3840) return 'ab300';
        return null;
      }
      if(space==='lowprofile'){
        if(need<=3584) return 'us280';
        return null;
      }
      if(need<=3584) return 'us280';
      if(need<=4096) return 'us320';
      if(need<=6912) return 'us540';
      if(need<=8960) return 'us700';
      return null;
    }
    function alternatives(primary,route,space){
      var map={
        ab120:['ab200'],ab200:['ab120','ab300'],ab300:['ab200'],
        us280:['us320'],us320:['us280','us540'],us540:['us320','us700'],us700:['us540']
      };
      var a=(map[primary]||[]).slice(0,2);
      if(space==='lowprofile') a=a.filter(function(k){return k==='us280';});
      return a;
    }
    function advise(){
      var days=parseInt(val('days')||1,10), base=parseInt(val('basewh')||0,10);
      var ac=val('acload'), charging=val('charging'), routeChoice=val('route'), existing=val('existing'), space=val('space');
      var reserve=1.20, usableFraction=0.80, acFactor=(ac==='light'?1.05:ac==='medium'?1.10:1.15);
      var period=days+' '+(days===1?'dag':'dagen');
      var daily=base*acFactor, chargeInput=form.querySelector('[name="chargewh"]');
      var entered=chargeInput&&chargeInput.value!==''?Number(chargeInput.value):0;
      var charge=(charging==='strong'||charging==='normal')&&Number.isFinite(entered)&&entered>=0&&entered<=50000?entered:0;
      var need=Math.ceil(Math.max(daily,daily*days-charge*Math.max(0,days-1))*reserve/usableFraction);
      var route=routeChoice==='advice'?((existing==='yes'||space==='lowprofile'||space==='underseat')?'installed':'allinone'):routeChoice;
      var primary=ac==='extreme'?null:capacityKey(route,need,space), alts=[], reason=[], warning=[], conditional=false, changedRoute=false;
      if(!primary && ac!=='extreme'){
        if(charging==='normal'||charging==='strong'){
          var largest=route==='allinone'?'ab300':space==='lowprofile'?'us280':'us700';
          if(specs[largest].wh>=Math.ceil(daily*reserve/usableFraction)){
            primary=largest;
            conditional=true;
          }
        }else if(route==='allinone'){
          var fixed=capacityKey('installed',need,space);
          if(fixed){primary=fixed;route='installed';changedRoute=true;}
        }
      }
      var profile=primary?(primary==='ab120'?'Energy Essential':(route==='installed'&&(primary==='us540'||primary==='us700'))?'Energy Pro':'Energy Freedom'):'Energy Pro — systeem op maat';
      if(conditional) profile+=' — met bijladen';
      var fmt=function(n){return Math.round(n).toLocaleString('nl-NL');};
      if(primary){
        if(!conditional) alts=alternatives(primary,route,space).filter(function(k){return specs[k].wh>=need;});
        reason.push((conditional?'Met voldoende bijladen kan ':'Bij jouw geschatte verbruik past ')+(products[primary]?products[primary].title:'de geselecteerde accu')+(conditional?' de basis vormen voor jouw energieoplossing.':' als '+(route==='allinone'?'complete energieoplossing':'opslag voor een vaste energie-installatie')+'.'));
        if(changedRoute) reason.push('De gewenste periode is zonder bijladen te groot voor één AccuBox. Deze grotere vaste accu is een alternatief; daarbij horen een passende omvormer en laadcomponenten.');
        if(conditional){
          var minimumCharge=Math.max(0,(daily*days-specs[primary].wh*usableFraction/reserve)/Math.max(1,days-1));
          var autonomous=specs[primary].wh*usableFraction/(reserve*daily);
          reason.push('Zonder bijladen overbrugt deze accu naar schatting '+autonomous.toLocaleString('nl-NL',{maximumFractionDigits:1})+' dagen. Voor '+days+' dagen is tussen de dagen minimaal circa '+fmt(Math.ceil(minimumCharge/10)*10)+' Wh bijladen per dag nodig.');
          warning.push('Dit advies geldt met voldoende bijladen. De opgegeven laadopbrengst is nog niet voldoende of niet ingevuld. Controleer of rijden, solar of een laadmoment deze benodigde energie werkelijk levert.');
        }
        if(route==='installed') warning.push('Voor een vaste installatie moeten omvormer, laadcomponenten, zekeringen, bekabeling en inbouwruimte passen bij jouw voertuig.');
        if(route==='allinone'&&existing==='yes') warning.push('Stem de AccuBox af op de energiecomponenten die al aanwezig zijn.');
      }else{
        reason.push(ac==='extreme'?'Je zoekt een installatie voor meer dan 3.000 W tegelijk. Dat vraagt een omvormer en complete installatie die op dit vermogen zijn ontworpen.':'Jouw autonomie en verbruik vragen meer opslag of een andere inbouwoplossing dan één passende accu uit deze selectie.');
        reason.push('CampVaro Energy Pro combineert passende opslag, laadmogelijkheden en installatieadvies voor jouw voertuig.');
        warning.push('Eén standaardproduct is voor deze combinatie geen volledige oplossing. We bepalen de benodigde capaciteit, laadopbrengst en componenten voor jouw Pro-setup.');
      }
      if(ac!=='light'&&ac!=='extreme') warning.push('Het gebruik van zware apparaten is indicatief meegewogen. Werkelijke wattages, gebruiksuren en gelijktijdige belasting bepalen de definitieve capaciteit.');
      if(space==='unknown') warning.push('Controleer de beschikbare ruimte en veilige bevestiging vóór bestelling.');
      if(days===4) warning.push('Voor 4+ dagen is gerekend met 4 dagen; vul voor langere verblijven je plannen aan bij het advies.');
      root.querySelector('.cv-result-profile').textContent=profile;
      root.querySelector('.cv-result-calc').textContent='Geschat verbruik: '+fmt(daily)+' Wh/dag. Voor '+period+': circa '+fmt(need)+' Wh nominale opslag'+(charge>0?' met '+fmt(charge)+' Wh bijladen tussen de dagen.':' zonder bijladen.')+' Uitgangspunt: een volle accu bij vertrek, 20% reserve en 80% bruikbare opslag. Bijladen aan het einde van de laatste dag telt niet mee.';
      root.querySelector('.cv-result-primary').innerHTML=primary?'<h3>'+(conditional?'Productadvies met bijladen':changedRoute?'Alternatieve route: vaste installatie':'Jouw productadvies')+'</h3>'+card(primary,products[primary]?products[primary].title:'Beste match'):'<h3>Jouw route: CampVaro Energy Pro</h3><p>Een complete energie-installatie afgestemd op jouw verbruik, autonomie en voertuig.</p><a class="button" href="/pages/contact">Bespreek mijn Energy Pro-setup</a>';
      root.querySelector('.cv-result-reason').innerHTML='<h3>Waarom dit advies?</h3><p>'+reason.join(' ')+'</p>';
      root.querySelector('.cv-result-warning').innerHTML=warning.length?'<div class="cv-warning"><strong>Goed om rekening mee te houden</strong><br>'+warning.join(' ')+'</div>':'';
      root.querySelector('.cv-result-alts').innerHTML=alts.length?'<h3>Meer energiereserve</h3>'+alts.map(function(k){return card(k,products[k]?products[k].title:k);}).join(''):'';
      root.querySelector('.cv-result-next').innerHTML=primary?'<div class="cv-advice-note">'+(route==='allinone'?'AccuBox bevat accu, omvormer, MPPT en laadbooster; de externe netlader is meegeleverd. Solar is optioneel.':'Deze vaste accu is onderdeel van een energie-installatie met passende laad- en omvormercomponenten.')+' <a href="/pages/contact">Vragen over de aansluiting in jouw voertuig? Vraag ons advies</a>.</div>':'';
      form.hidden=true; result.hidden=false; result.scrollIntoView({behavior:'smooth',block:'start'});
    }

    root.querySelector('.cv-next').addEventListener('click',function(){
      if(!valid()){steps[idx].querySelector('label').scrollIntoView({behavior:'smooth',block:'center'});return;}
      if(idx<steps.length-1) show(idx+1); else advise();
    });
    root.querySelector('.cv-prev').addEventListener('click',function(){if(idx>0)show(idx-1);});
    root.querySelector('.cv-restart').addEventListener('click',function(){form.reset();result.hidden=true;form.hidden=false;show(0);});
    show(0);
  }
  function boot(){document.querySelectorAll('[id^="CampVaroEnergyAdvisor-"]').forEach(init);}
  document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[id^="CampVaroEnergyAdvisor-"]')||e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('campvaro-sticky-buy')) {
  customElements.define('campvaro-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.root = document.getElementById('MainProduct-' + this.dataset.section);
      this.buy = this.querySelector('[data-cv-buy]');
      if (!this.root || !this.buy) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, options);
      document.addEventListener('focusin', this.schedule, options);
      document.addEventListener('focusout', this.schedule, options);
      this.root.addEventListener('change', this.schedule, options);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', this.schedule, options);
      this.productObserver = new MutationObserver(this.schedule);
      this.productObserver.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true });
      this.overlayObserver = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target) && record.target !== document.body)) this.schedule();
        if (records.some(record => record.target === document.body && record.attributeName === 'class')) this.schedule();
      });
      this.overlayObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open', 'aria-hidden', 'style', 'hidden'] });
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.productObserver?.disconnect();
      this.overlayObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      document.body.style.removeProperty('--cv-buy-height');
    }
    originalButton() {
      return this.root.querySelector('product-form form[action*="/cart/add"] button[name="add"]');
    }
    sync() {
      const original = this.originalButton();
      if (!original) { this.hidden = true; return; }
      this.buy.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true' || original.classList.contains('loading');
      const label = original.querySelector('span')?.textContent.trim() || original.textContent.trim();
      if (this.buy.textContent !== label) this.buy.textContent = label;
      const priceRoot = this.root.querySelector('[id="price-' + this.dataset.section + '"]');
      const price = priceRoot?.querySelector('.price--on-sale .price-item--sale') || priceRoot?.querySelector('.price-item--regular');
      const priceTarget = this.querySelector('[data-cv-price]');
      if (price) priceTarget.textContent = price.textContent.trim();
      priceTarget.hidden = !price || priceRoot.classList.contains('visibility-hidden');
      const stock = this.root.querySelector('[id="Inventory-' + this.dataset.section + '"]');
      this.querySelector('[data-cv-stock]').textContent = stock && !stock.classList.contains('visibility-hidden') ? stock.textContent.trim() : '';
      const error = this.root.querySelector('.product-form__error-message');
      const errorTarget = this.querySelector('[data-cv-error]');
      const errorText = error && !error.closest('[hidden]') ? error.textContent.trim() : '';
      if (errorTarget.textContent !== errorText) errorTarget.textContent = errorText;
      errorTarget.hidden = !errorText;
      const focused = document.activeElement;
      const keyboard = window.innerWidth < 750 && focused?.matches('input:not([type="radio"]):not([type="checkbox"]), textarea, select');
      const overlay = document.body.className.includes('overflow-hidden') || !!document.querySelector('dialog[open], cart-drawer.active, .cart-notification.active, menu-drawer details[open], details-modal details[open], product-modal[open]');
      const cookie = [...document.querySelectorAll('#shopify-pc__banner, #onetrust-banner-sdk, .cc-window')].some(el => el.getBoundingClientRect().height > 0 && getComputedStyle(el).visibility !== 'hidden');
      this.hidden = original.getBoundingClientRect().bottom >= 0 || overlay || keyboard || cookie;
      if (!this.hidden) document.body.style.setProperty('--cv-buy-height', this.getBoundingClientRect().height + 'px');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
